import { render, staticRenderFns } from "./testFormat.vue?vue&type=template&id=d5fa4e6c&scoped=true"
import script from "./testFormat.vue?vue&type=script&lang=js"
export * from "./testFormat.vue?vue&type=script&lang=js"
import style0 from "./testFormat.vue?vue&type=style&index=0&id=d5fa4e6c&prod&scoped=true&lang=scss"
import style1 from "./testFormat.vue?vue&type=style&index=1&id=d5fa4e6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fa4e6c",
  null
  
)

export default component.exports